import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';

import useFetchAnonymousHelp from '../../hooks/useFetchAnonymousHelp';
import { ToastManager } from '../../services/toast/utils';
import { t } from '../../services/translation/translation';
import { GradientButton } from '../button/GradientButton';

type Props = {
  trip: TripOutput;
  onClose: () => void;
};

export const HelpAnonymousButton = ({ onClose }: Props) => {
  const { jwtToken } = useParams();
  invariant(jwtToken, 'Expected jwtToken');

  const { mutate: alertAnonymousAllocab, isLoading: isLoadingAnonymous } = useFetchAnonymousHelp(jwtToken);

  return (
    <GradientButton
      className="w-full"
      onClick={() =>
        alertAnonymousAllocab(undefined, {
          onSuccess: () => {
            ToastManager.show({
              message: t('help-details-modal.alert-success'),
              severity: 'success',
            });
            onClose();
          },
        })
      }
      isLoading={isLoadingAnonymous}
    >
      {t('help-details-modal.alert-allocab')}
    </GradientButton>
  );
};
